import { ServiceExpressQuery, ServiceParcelQuery } from '~/gql'
import { CapabilitiesState } from './reducers'

// eslint-disable-next-line @typescript-eslint/naming-convention
type serviceQuery$data = ServiceExpressQuery | ServiceParcelQuery
export const ACTION = {
  UPDATE_CAPABILITIES_REQUESTED: 'UPDATE_CAPABILITIES_REQUESTED@basket',
  UPDATE_CAPABILITIES_SUCCESS: 'UPDATE_CAPABILITIES_SUCCESS@basket',
  UPDATE_CAPABILITIES_FAILURE: 'UPDATE_CAPABILITIES_FAILURE@basket',
  PREFILL_CAPABILITIES_AFTER_FAILED_PAYMENT: 'PREFILL_CAPABILITIES_AFTER_FAILED_PAYMENT@basket',
} as const

type LookupCriteria = {
  originCountry: string
  destinationCountry: string
  carrierKey: string | null
  parcelTypeKey: string | null
  toPostalCode?: string
  fromPostalCode?: string
  productKey?: string
  city?: string
}

export type UpdateCapabilitiesRequestedAction = {
  type: typeof ACTION.UPDATE_CAPABILITIES_REQUESTED
  payload: {
    shipmentId: number
    isLoading: boolean
    lookupCriteria: LookupCriteria
  }
}

export const updateCapabilitiesRequested = (
  shipmentId: number,
  lookupCriteria: LookupCriteria,
  isLoading: boolean = true
): UpdateCapabilitiesRequestedAction => ({
  type: ACTION.UPDATE_CAPABILITIES_REQUESTED,
  payload: {
    shipmentId,
    isLoading,
    lookupCriteria,
  },
})

export type UpdateCapabilitiesSuccessAction = {
  type: typeof ACTION.UPDATE_CAPABILITIES_SUCCESS
  payload: {
    shipmentId: number
    capabilities: serviceQuery$data
  }
}

export const updateCapabilitiesSuccess = (
  shipmentId: number,
  capabilities: serviceQuery$data
): UpdateCapabilitiesSuccessAction => ({
  type: ACTION.UPDATE_CAPABILITIES_SUCCESS,
  payload: {
    shipmentId,
    capabilities,
  },
})

export type UpdateCapabilitiesFailureAction = {
  type: typeof ACTION.UPDATE_CAPABILITIES_FAILURE
  error: true
  payload: {
    shipmentId: number
    error: Error
  }
}

export const updateCapabilitiesFailure = (shipmentId: number, error: Error): UpdateCapabilitiesFailureAction => ({
  type: ACTION.UPDATE_CAPABILITIES_FAILURE,
  error: true,
  payload: {
    shipmentId,
    error,
  },
})

export type PrefillCapabilitiesAfterFailedPaymentAction = {
  type: typeof ACTION.PREFILL_CAPABILITIES_AFTER_FAILED_PAYMENT
  payload: CapabilitiesState
}

export const prefillCapabilitiesAfterFailedPaymentAction = (
  capabilitiesState: CapabilitiesState
): PrefillCapabilitiesAfterFailedPaymentAction => ({
  type: ACTION.PREFILL_CAPABILITIES_AFTER_FAILED_PAYMENT,
  payload: {
    ...capabilitiesState,
  },
})

export type Action =
  | UpdateCapabilitiesRequestedAction
  | UpdateCapabilitiesSuccessAction
  | UpdateCapabilitiesFailureAction
  | PrefillCapabilitiesAfterFailedPaymentAction
